import { RRGarmentFileListModel } from '../models/file-list.model';

export class CustomResourceProvider {
  private _fileList: RRGarmentFileListModel[];

  constructor(fileList: RRGarmentFileListModel[]) {
    this._fileList = fileList;
  }

  async requestURL(uri: string, _identifier: string): Promise<string> {
    if (uri === 'livingroom_cubemap_cc') {
      return '../../../../assets/viewer/configs/' + uri;
    }
    const product = this._fileList
      ? this._fileList.find((x) => x.filename == uri)
      : null;

    return product ? product.download_url : null;
  }
}
